import { render } from "./CountySecretaryDashboard.vue?vue&type=template&id=058e20a7&scoped=true"
import script from "./CountySecretaryDashboard.vue?vue&type=script&lang=js"
export * from "./CountySecretaryDashboard.vue?vue&type=script&lang=js"

import "./CountySecretaryDashboard.vue?vue&type=style&index=0&id=058e20a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058e20a7"]])

export default __exports__